<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" hide-details option="Last 30 days"/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete label="Formula" dense outlined hide-details :items="formulas" item-value="id" item-text="name" v-model="formulaId"/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="Show" dense outlined hide-details :items="[{value:true,text:'Volume'},{value:false,text:'$ Value'}]" v-model="volume"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Blending activity', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsBlendingActivity',
  mixins: [printHtml],
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      formulas: [{name:'All formulas',id:null},{name:'No formula',id:''},{divider:true}],
      formulaId: null,
      volume: true,
      blends: [],
      loading: true,
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    formulaName() {
      const formula = this.formulas.find(formula => formula.id === this.formulaId);
      return formula ? formula.text : '';
    },
    blendsList() {
      if (this.formulaId === null)
        return this.blends;
      return this.blends.filter(blend =>
        (this.formulaId === '' && blend.formulaId === null) || (this.formulaId !== '' && this.formulaId === blend.formulaId)
      );
    }
  },
  async created() {
    this.$emit('name', 'Blending activity')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
    if (this.$route.query.formulaId)
      this.formulaId = this.$route.query.formulaId;

    this.$lazyListLoad(this.formulas, 'formulas2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsBlendingActivity($from:Date!,$to:Date!) {
                                                blendActivity(from:$from,to:$to) {
                                                  id,date,formulaId,formulaName,
                                                  inputs{type,vesselName,volume,value},
                                                  output{type,vesselName,volume,value}
                                                }
                                              }`,
                                          {from:this.from,to:this.to});
      if (!results.error)
        this.blends = results.data.blendActivity;
      this.loading = false;
    },

    report() {
    const lines = [
                    `<style>
                      @page {size:landscape}
                      .reports-blend-activity {font-family: Roboto, sans-serif; font-size:14px;width:100%;border-spacing:0}
                      .reports-blend-activity th {height:36px;padding:0 16px}
                      .reports-blend-activity td {height:36px;padding:0 16px}
                      .reports-blend-activity .title {font-size:18px;text-transform:uppercase}
                      .reports-blend-activity .sup-title {font-weight:normal;font-size:22px}
                      .reports-blend-activity .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                      .reports-blend-activity .header th {border-bottom:1px solid #000;margin-bottom:20px}
                      .reports-blend-activity .text-left {text-align:left}
                      .reports-blend-activity .text-right {text-align:right}
                      .reports-blend-activity .font-weight-bold {font-weight:bold}
                    </style>
                    <table class="reports-blend-activity">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="6" class="title">Blending activity</th>
                        </tr>
                        <tr>
                           <th colspan="6" class="sub-title">${this.dateDisplay}</th>
                        </tr>
                        <tr class="header">
                            <th width="15%" class="text-left">Date</th>
                            <th width="20%" class="text-left">Formula</th>
                            <th width="10%" class="text-left">In/Out</th>
                            <th width="20%" class="text-left">Type</th>
                            <th width="20%" class="text-left">Vessel</th>
                            <th width="15%" class="text-left text-right">${this.volume ? 'Volume' : 'Value'}</th>
                          </tr>
                      </thead>
                      <tbody>`
    ];
    for (const blend of this.blendsList) {
      let i = 0;
      for (const input of blend.inputs) {
        lines.push(`<tr>`);
        if (i === 0) {
          lines.push(`<td>${this.$formatDate(blend.date)}</td>`);
          lines.push(`<td>${blend.formulaName ? blend.formulaName : ''}</td>`);
        }
        else {
          lines.push(`<td/>`)
          lines.push(`<td/>`)
        }
        lines.push(`<td>IN</td>`);
        lines.push(`<td>${input.type}</td>`);
        lines.push(`<td>${input.vesselName}</td>`);
        lines.push(`<td class="text-right">${this.volume ? input.volume : `$${input.value}`}</td>`);
        lines.push(`</tr>`);
        i++
      }
      lines.push(`<td/>`)
      lines.push(`<td/>`)
      lines.push(`<td>OUT</td>`);
      lines.push(`<td>${blend.output.type}</td>`);
      lines.push(`<td>${blend.output.vesselName}</td>`);
      lines.push(`<td class="text-right">${this.volume ? blend.output.volume : `$${blend.output.value}`}</td>`);
      lines.push(`</tr>`);
    }
    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,,,,`,
                      `"Blending activity",,,,,`,
                      `"${this.dateDisplay}",,,,,`,
                      `"Date","Formula","In/Out","Type","Vessel","Volume"`
                    ];
      for (const blend of this.blendsList) {
        let i = 0;
        for (const input of blend.inputs) {
          let line = i === 0 ? `"${blend.date}","${blend.formulaName ? blend.formulaName : ''}",` : `,,`;
          line += `"IN","${input.type}","${input.vesselName}","${input.volume}"`;
          lines.push(line);
          i++
        }
        lines.push(`,,"OUT","${blend.output.type}","${blend.output.vesselName}","${blend.output.volume}"`);
      }

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Blending activity.csv');
    }
  }
}
</script>